import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MultichatComponent } from './multichat/multichat.component';
import { IqEyeComponent } from './iq-eye/iq-eye.component';
import { ParallaxChatComponent } from './parallax-chat/parallax-chat.component';
import { PersonalityComponent } from './personality/personality.component';

const routes: Routes = [
  { path: '', redirectTo: 'executive-chat', pathMatch: 'full' },
  { path: 'executive-chat', component: MultichatComponent },
  { path: 'iq', component: IqEyeComponent },
  { path: 'personality', component: PersonalityComponent },
  { path: 'pears-relax', component: ParallaxChatComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TeamsRoutingModule {}

export { routes };
